import React, { ReactNode, Component } from 'react';
import styled from '@emotion/styled';
import { SideNavConsumer } from '../context/SideNavContext';
import HoverLabel from './HoverLabel';

const NavLink = styled.a`
  position: relative;
  display: flex;
  flex-direction: row;
  align-items: center;

  padding: 1rem 0.75rem;
  border-bottom: 1px solid #5ca0d3;
  text-decoration: none;
  color: #c8dff0;

  :hover {
    background-color: #57a8e6;
    color: #ffffff;

    svg {
      path {
        fill: #ffffff;
      }
    }
  }
`;

const NavLinkText = styled.span`
  white-space: nowrap;
  overflow: hidden;
  user-select: none;
  padding: 0.05rem 0;
`;

const IconWrapper = styled.div`
  margin-right: 1rem;
  padding: 0.05rem 0;

  svg {
    width: 24px;
    max-width: 24px;
    max-height: 19px;

    path {
      fill: #c8dff0;
    }
  }
`;

interface Props {
  children: ReactNode;
  link: string;
  linkText: string;
}

class NavItem extends Component<Props> {
  state = {
    hover: false,
  };

  handleMouseEnter = () => this.setState({ hover: true });
  handleMouseLeave = () => this.setState({ hover: false });

  render() {
    return (
      <SideNavConsumer>
        {({ state }) => (
          <NavLink
            href={this.props.link}
            onMouseEnter={!state.isSideNavOpen ? this.handleMouseEnter : () => null}
            onMouseLeave={!state.isSideNavOpen ? this.handleMouseLeave : () => null}
          >
            <IconWrapper>{this.props.children}</IconWrapper>
            <NavLinkText>{this.props.linkText}</NavLinkText>
            {/* Only show if sidebar isn't open, and element is hovered. */}
            <HoverLabel
              active={!state.isSideNavOpen && this.state.hover}
              text={this.props.linkText}
            />
          </NavLink>
        )}
      </SideNavConsumer>
    );
  }
}

export default NavItem;
export { NavItem };
